const copyTextToClipboard = (text) => {
    navigator.clipboard
        .writeText(text)
        .then(() => {
            showToast('Copied to clipboard', 'success');
        })
        .catch((err) => {
            console.error('Failed to copy text: ', err);
            showToast('Failed to copy text', 'error');
        });
};

document.querySelectorAll('[data-copyable]').forEach((element) => {
    if (element) element.addEventListener('click', () => copyTextToClipboard(element.innerText));
});

const showToast = (message, type = 'neutral') => {
    const toast = document.createElement('div');
    toast.className = `toast toast--${type}`;
    toast.innerText = message;

    document.body.appendChild(toast);

    setTimeout(() => {
        toast.classList.add('show');
    }, 10);

    setTimeout(() => {
        toast.classList.remove('show');
        setTimeout(() => {
            document.body.removeChild(toast);
        }, 500);
    }, 1000);
};
